export const NAVIGATION_TARGET_XY_TOLERANCE = 5;
export const NAVIGATION_TARGET_Z_TOLERANCE = 0.5;
export const NAVIGATION_TARGET_HEADING_TOLERANCE = 0.35;

const angularDistance = (first, second) => Math.abs(Math.atan2(
  Math.sin(first - second),
  Math.cos(first - second)
));

const numericValue = (value) => (
  value === null || value === undefined || value === '' ? Number.NaN : Number(value)
);

export const hasRobotReachedTarget = (robotStatus, target) => {
  const robotX = numericValue(robotStatus?.LocationX);
  const robotY = numericValue(robotStatus?.LocationY);
  const targetX = numericValue(target?.x);
  const targetY = numericValue(target?.y);

  if (![robotX, robotY, targetX, targetY].every(Number.isFinite)) {
    return false;
  }

  if (Math.hypot(robotX - targetX, robotY - targetY) > NAVIGATION_TARGET_XY_TOLERANCE) {
    return false;
  }

  const robotZ = numericValue(robotStatus?.LocationZ);
  const targetZ = numericValue(target?.z);
  if (
    Number.isFinite(robotZ)
    && Number.isFinite(targetZ)
    && Math.abs(robotZ - targetZ) > NAVIGATION_TARGET_Z_TOLERANCE
  ) {
    return false;
  }

  const robotHeading = numericValue(robotStatus?.Angle);
  const targetHeading = numericValue(target?.angle ?? target?.heading);
  return !(
    Number.isFinite(robotHeading)
    && Number.isFinite(targetHeading)
    && angularDistance(robotHeading, targetHeading) > NAVIGATION_TARGET_HEADING_TOLERANCE
  );
};

const roundedNumber = (value, precision) => {
  const number = numericValue(value);
  return Number.isFinite(number)
    ? Number(number.toFixed(precision))
    : Number.NaN;
};

export const snapshotRoutePreviewTarget = (target, currentTarget, fallbackZ) => {
  if (!target) return null;

  const x = roundedNumber(target.x, 3);
  const y = roundedNumber(target.y, 3);
  if (!Number.isFinite(x) || !Number.isFinite(y)) return null;

  const currentZ = roundedNumber(currentTarget?.z, 3);
  const robotZ = roundedNumber(fallbackZ, 3);
  const targetZ = roundedNumber(target.z, 3);
  const z = Number.isFinite(currentZ)
    ? currentZ
    : Number.isFinite(robotZ)
      ? robotZ
      : Number.isFinite(targetZ)
        ? targetZ
        : 0;

  const requestedHeading = roundedNumber(target.angle ?? target.heading, 4);
  const currentHeading = roundedNumber(currentTarget?.angle, 4);
  const angle = Number.isFinite(requestedHeading)
    ? requestedHeading
    : Number.isFinite(currentHeading)
      ? currentHeading
      : 0;

  return { x, y, z, angle };
};
